import classNames from 'classnames';
import {map} from 'lodash';
import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import Dropzone from 'react-dropzone';
import './index.css';

export const CollectionDetails = ({
  details,
  isEditing,
  errors,
  onChangeDetails,
  onUpdateCollection,
  onOrderCollections,
  collectionsList,
  onUpload,
  onUploadBackground,
  onCreateCollection,
}) => {
  return (
    <div id="updateCollection" className="col-md-6">
      <div className="box box-default">
        <div className="box-header with-border">
          <h3 className="box-title pull-left">
            {isEditing ? `Editing ${details.name}` : 'Create new collection'}
          </h3>
        </div>
        <div style={{padding: '15px'}}>
          {isEditing && (
            <div>
              <div className="infoWrapper">
                <div className="keys">ID</div>
                <div className="values">{details.id}</div>
              </div>
              <hr />
            </div>
          )}
          <div className="infoWrapper">
            <div className="keys">Name</div>
            <div className="name">
              <div className="nameContainer">
                <div
                  className={classNames(
                    'form-group',
                    errors.name && 'has-error',
                  )}>
                  <input
                    className="form-control"
                    value={details.name}
                    onChange={event =>
                      onChangeDetails(event.target.value, 'name')
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <hr />

          <div className="infoWrapper">
            <div className="keys">Description (optionnel)</div>
            <div className="name">
              <div className="nameContainer">
                <div
                  className={classNames(
                    'form-group',
                    errors.description && 'has-error',
                  )}>
                  <textarea
                    className="form-control"
                    value={details.description}
                    onChange={event =>
                      onChangeDetails(event.target.value, 'description')
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="infoWrapper">
            <div style={{color: errors.startDate && 'red'}} className="keys">
              Available
            </div>
            <div className="nameContainer">
              <div style={{color: errors.startDate && 'red'}}>Start</div>
              <div>
                <DatePicker
                  className="inputDatePicker"
                  selected={
                    details.startDate ? new Date(details.startDate) : null
                  }
                  onChange={date => {
                    onChangeDetails(moment(date).utc().format(), 'startDate');
                  }}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="d/M/yyyy hh:mm aa"
                  timeCaption="time"
                  placeholderText="Select Date"
                />
              </div>
            </div>
            <div className="nameContainer">
              <div>End</div>
              <DatePicker
                className="inputDatePicker"
                selected={details.endDate ? new Date(details.endDate) : null}
                onChange={date => {
                  onChangeDetails(moment(date).utc().format(), 'endDate');
                }}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="d/M/yyyy hh:mm aa"
                timeCaption="time"
                placeholderText="Select Date"
              />
            </div>
            {/* <div className="nameContainer">
              <div>No limit</div>
              <input
                type="checkbox"
                checked={this.state.checkbox}
                onChange={() => {
                  this.setState({checkbox: !this.state.checkbox});
                  if (edit && !this.state.checkbox && data.endDate) {
                    onBlur('', 'endDate', data.id);
                  }
                  this.onChangeInput(null, 'endDate');
                }}
              />
            </div> */}
          </div>
          <hr />
          <div className="infoWrapper">
            <div className="keys">Position</div>
            <div className="form-group">
              <select
                className="form-control"
                value={details.position + 1}
                onChange={event => {
                  if (isEditing) {
                    onOrderCollections(event.target.value - 1);
                  } else {
                    onChangeDetails(event.target.value - 1, 'position');
                  }
                }}>
                {map(collectionsList, (value, key) => (
                  <option key={value.id} value={key + 1}>
                    {key + 1}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <hr />
          <div className="infoWrapper">
            <div className="keys" style={{color: errors.imageUrl && 'red'}}>
              Icone
            </div>
            {details.imageUrl && (
              <div className="jerseyItem">
                <img
                  style={{
                    objectFit: 'cover',
                    width: 24,
                    height: 24,
                    borderRadius: 24,
                  }}
                  src={`${details.imageUrl}`}
                  alt=""
                />
              </div>
            )}
            <div style={{marginLeft: '20px'}}>
              <Dropzone
                onDrop={acceptedFiles => {
                  const img = new Image();
                  img.src = acceptedFiles[0].preview;
                  img.onload = value => {
                    onUpload(acceptedFiles[0]);
                  };
                }}
                className="btn btn-warning">
                Upload
              </Dropzone>
            </div>
          </div>

          <div className="infoWrapper">
            <div
              className="keys"
              style={{color: errors.backgroundImageUrl && 'red'}}>
              Image de background
            </div>
            {details.backgroundImageUrl && (
              <div className="jerseyItem">
                <img
                  style={{
                    objectFit: 'cover',
                    width: 375,
                    height: 240,
                    borderRadius: 24,
                  }}
                  src={`${details.backgroundImageUrl}`}
                  alt=""
                />
              </div>
            )}
            <div style={{marginLeft: '20px'}}>
              <Dropzone
                onDrop={acceptedFiles => {
                  const img = new Image();
                  img.src = acceptedFiles[0].preview;
                  img.onload = value => {
                    onUploadBackground(acceptedFiles[0]);
                  };
                }}
                className="btn btn-warning">
                Upload
              </Dropzone>
            </div>
          </div>

          <hr />
          <div className="infoWrapper">
            <div className="keys">Epingler la collection</div>
            <i
              style={{color: 'black'}}
              onClick={() => {
                onChangeDetails(!details.isPinned, 'isPinned');
              }}
              className={classNames('fa fa-2x', {
                'fa-toggle-on': details.isPinned,
                'fa-toggle-off': !details.isPinned,
              })}
            />
          </div>
          <div className="infoWrapper">
            <div className="keys">Collection éphémère ?</div>
            <i
              style={{color: 'black'}}
              onClick={() => {
                onChangeDetails(!details.isDrop, 'isDrop');
              }}
              className={classNames('fa fa-2x', {
                'fa-toggle-on': details.isDrop,
                'fa-toggle-off': !details.isDrop,
              })}
            />
          </div>
          <hr />
          <div className="text-center">
            <button
              className="btn btn-success"
              onClick={isEditing ? onUpdateCollection : onCreateCollection}>
              {isEditing ? 'Modify' : 'Create'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Jerseys/CollectionDetails/index.js